import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type T_PageTitle = {
  title: string;
  link?: string;
}[];

const initialData: T_PageTitle = [{ title: "Dashboard" }];

export const pageTitleSlice = createSlice({
  name: "pageTitle",
  initialState: initialData,
  reducers: {
    setPageTitle: (state, { payload }: PayloadAction<T_PageTitle>) => {
      const arr = payload.slice();
      return arr;
    },
  },
});

export const { setPageTitle } = pageTitleSlice.actions;
